import React from "react";

// HTSS Ops brand mark: rounded gradient tile with ascending analytics bars.
export default function BrandLogo({ size = 26 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="htss-brand" x1="0" y1="32" x2="32" y2="0" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4F46E5" />
          <stop offset="1" stopColor="#818CF8" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="30" height="30" rx="9" fill="url(#htss-brand)" />
      <rect x="8" y="16" width="4" height="8" rx="1.5" fill="#fff" opacity="0.95" />
      <rect x="14" y="12" width="4" height="12" rx="1.5" fill="#fff" opacity="0.95" />
      <rect x="20" y="8" width="4" height="16" rx="1.5" fill="#fff" opacity="0.95" />
    </svg>
  );
}
